.list-container {
    flex: 1;
    min-height: 0;
    width: 80%;
    background-color: var(--white);
}
